module.exports = __webpack_public_path__ + "components/country-flag/static/so-1d5717f3c52ed1e27d1b05372a761e87.svg";